import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../HomePage/Faq/Faq.css";
const HrdFaqMain = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div className="faqMainContainer">
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is HRD Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              HRD Attestation is the verification of your educational documents
              by the State Human Resource Development Department to confirm that
              the degree, diploma, or certificate is genuine. It is the first
              and most important step for overseas employment, higher education,
              or migration.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Which documents require HRD Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              <ul>
                You must submit original educational documents, such as:
                <ul>
                  <li> Degree Certificate</li>
                  <li> Diploma Certificate</li>
                  <li> HSC/SSC Mark Sheets (depending on country)</li>
                  <li> PG Degree / Professional Qualification Certificates</li>
                  <li> Nursing, Pharmacy, Engineering certificates</li>
                </ul>
                Only state-issued educational documents can be attested by HRD.
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is HRD Attestation mandatory for all countries?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              HRD attestation is mandatory for UAE, Qatar, Kuwait, Saudi Arabia,
              and other GCC countries. Some countries may allow SDM or MEA
              attestation, but GCC usually requires state HRD for job visa
              processing.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does HRD Attestation take in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Timeline varies by university/state:
              <ul>
                <li> Fast-track: 5–10 working days</li>
                <li> Normal process: 15–30 working days</li>
                <li>
                  {" "}
                  Some universities may take up to 45–60 days, depending on
                  verification.
                </li>
              </ul>
              The timeline depends on how quickly your university verifies your
              certificate.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What are the required documents for HRD Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              You will need:
              <ul>
                <li> ✔ Original Degree/Diploma Certificate</li>
                <li>✔ 1 Xerox copy of certificate</li>
                <li>✔ Passport copy</li>
                <li>✔ Offer letter (if required by some states)</li>
                <li>✔ 2–3 passport-size photos</li>
                <li>✔ University verification fee (varies)</li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Can HRD Attestation be done without the student physically
                present?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes.
              <br />
              You can authorize a trusted agency to complete HRD attestation on
              your behalf with a signed authorization letter. This is helpful
              for students working in Bangalore or abroad.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                What is the difference between HRD Attestation and MEA
                Attestation?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              <ul>
                <li>
                  {" "}
                  HRD Attestation: Done by the State HRD for educational
                  documents only.
                </li>
                <li>
                  MEA Attestation: Done by the Ministry of External Affairs
                  after HRD.
                </li>
              </ul>
              Most countries require both HRD + MEA, followed by Embassy
              attestation.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Why does HRD Attestation take longer than other attestations?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              HRD verifies your certificate directly with the issuing
              university. If your university delays verification or requires
              additional fees, the process becomes slower. This is why HRD is
              the longest step in the attestation chain.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is the cost of HRD Attestation in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Costs vary depending on:
              <ul>
                <li> State/University verification fee</li>
                <li> Document type</li>
                <li> Service fee of attestation agency</li>
                <li> Courier charges (if applicable)</li>
              </ul>
              Average range: ₹1,500–₹6,500 per document, depending on urgency
              and state.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is HRD Attestation needed before Embassy Attestation? </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes.
              <br />
              For most countries, especially in the Middle East (UAE, Qatar,
              Kuwait, Saudi Arabia, Oman), HRD attestation is the first
              mandatory step before MEA and Embassy attestation.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default HrdFaqMain;
